var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart_xright"},[_c('div',{ref:"chartb",staticClass:"charts",staticStyle:{"width":"974px","height":"161px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }